[
    {
        "userType": "administrator",
        "menu": [
            {
                "code": "policies",
                "value": "policies",
                "label": "Policies",
                "icon": "Policies"
            },
            {
                "code": "summary",
                "label": "Summary",
                "value": "summary"
            },
            {
                "code": "renewal",
                "label": "Renewal",
                "value": "renewal"
            },
            {
                "code": "terms",
                "label": "Terms",
                "value": "terms"
            },
            {
                "code": "underwriterCoverageAdjustment",
                "label": "Underwriting",
                "value": "underwriterCoverageAdjustment"
            },
            {
                "code": "liabilityExposure",
                "label": "Liability Exposure",
                "value": "liabilityExposure"
            },
            {
                "code": "policy",
                "label": "Policy",
                "value": "policy"
            },
            {
                "code": "applicant",
                "label": "Insured",
                "value": "applicant"
            },
            {
                "code": "securemyoffer.insuranceApplicant",
                "label": "Insurance Applicant",
                "value": "securemyoffer.insuranceApplicant"
            },
            {
                "code": "securemyoffer.additionalSellers",
                "label": "Additional Sellers",
                "value": "securemyoffer.additionalSellers"
            },
            {
                "code": "sn-commercial.business",
                "label": "Business Info",
                "value": "sn-commercial.business"
            },
            {
                "code": "sn-commercial.insuranceHistory",
                "label": "Insurance History",
                "value": "sn-commercial.insuranceHistory"
            },
            {
                "code": "sn-commercial.coverages",
                "label": "Coverages",
                "value": "sn-commercial.coverages"
            },
            {
                "code": "sn-commercial.additionalInsureds",
                "label": "Additional Insureds",
                "value": "sn-commercial.additionalInsureds"
            },
            {
                "code": "sn-commercial.lossPayees",
                "label": "Loss Payees",
                "value": "sn-commercial.lossPayees"
            },
            {
                "code": "sn-commercial.employment",
                "label": "Employment",
                "value": "sn-commercial.employment"
            },
            {
                "code": "sn-commercial.memberships",
                "label": "Memberships",
                "value": "sn-commercial.memberships"
            },
            {
                "code": "securemyoffer.secureMyOffer",
                "label": "Secure My Offer",
                "value": "securemyoffer.secureMyOffer"
            },
            {
                "code": "auto.drivers",
                "label": "Drivers",
                "value": "auto.drivers"
            },
            {
                "code": "auto.vehicles",
                "label": "Vehicles",
                "value": "auto.vehicles"
            },
            {
                "code": "usauto.drivers",
                "label": "Drivers",
                "value": "usauto.drivers"
            },
            {
                "code": "usauto.vehicles",
                "label": "Vehicles",
                "value": "usauto.vehicles"
            },
            {
                "code": "home.residents",
                "label": "Residents",
                "value": "home.residents"
            },
            {
                "code": "home.dwellings",
                "label": "Dwellings",
                "value": "home.dwellings"
            },
            {
                "code": "ushome.residents",
                "label": "Residents",
                "value": "ushome.residents"
            },
            {
                "code": "ushome.dwellings",
                "label": "Dwellings",
                "value": "ushome.dwellings"
            },
            {
                "code": "payment",
                "label": "Payment",
                "value": "payment"
            },
            {
                "code": "documents",
                "label": "Documents",
                "value": "documents"
            },
            {
                "code": "notes",
                "label": "Notes",
                "value": "note"
            },
            {
                "code": "history",
                "label": "History",
                "value": "history"
            },
            {
                "code": "logs",
                "label": "API Logs",
                "value": "logs"
            },
            {
                "code": "testMode",
                "label": "Test Mode",
                "value": "testMode"
            }
        ]
    },
    {
        "userType": "broker",
        "menu": [
            {
                "code": "policies",
                "value": "policies",
                "label": "Policies",
                "icon": "Policies"
            },
            {
                "code": "summary",
                "label": "Summary",
                "value": "summary"
            },
            {
                "code": "renewal",
                "label": "Renewal",
                "value": "renewal"
            },
            {
                "code": "terms",
                "label": "Terms",
                "value": "terms"
            },
            {
                "code": "liabilityExposure",
                "label": "Liability Exposure",
                "value": "liabilityExposure"
            },
            {
                "code": "policy",
                "label": "Policy",
                "value": "policy"
            },
            {
                "code": "applicant",
                "label": "Insured",
                "value": "applicant"
            },
            {
                "code": "securemyoffer.insuranceApplicant",
                "label": "Insurance Applicant",
                "value": "securemyoffer.insuranceApplicant"
            },
            {
                "code": "securemyoffer.additionalSellers",
                "label": "Additional Sellers",
                "value": "securemyoffer.additionalSellers"
            },
            {
                "code": "sn-commercial.business",
                "label": "Business Info",
                "value": "sn-commercial.business"
            },
            {
                "code": "sn-commercial.employment",
                "label": "Employment",
                "value": "sn-commercial.employment"
            },
            {
                "code": "sn-commercial.memberships",
                "label": "Memberships",
                "value": "sn-commercial.memberships"
            },
            {
                "code": "sn-commercial.insuranceHistory",
                "label": "Insurance History",
                "value": "sn-commercial.insuranceHistory"
            },
            {
                "code": "sn-commercial.coverages",
                "label": "Coverages",
                "value": "sn-commercial.coverages"
            },
            {
                "code": "sn-commercial.additionalInsureds",
                "label": "Additional Insureds",
                "value": "sn-commercial.additionalInsureds"
            },
            {
                "code": "sn-commercial.lossPayees",
                "label": "Loss Payees",
                "value": "sn-commercial.lossPayees"
            },
            {
                "code": "securemyoffer.secureMyOffer",
                "label": "Secure My Offer",
                "value": "securemyoffer.secureMyOffer"
            },
            {
                "code": "auto.drivers",
                "label": "Drivers",
                "value": "driver"
            },
            {
                "code": "auto.vehicles",
                "label": "Vehicles",
                "value": "vehicle"
            },
            {
                "code": "usauto.drivers",
                "label": "Drivers",
                "value": "driver"
            },
            {
                "code": "usauto.vehicles",
                "label": "Vehicles",
                "value": "vehicle"
            },
            {
                "code": "home.residents",
                "label": "Residents",
                "value": "resident"
            },
            {
                "code": "home.dwellings",
                "label": "Dwellings",
                "value": "dweling"
            },
            {
                "code": "ushome.residents",
                "label": "Residents",
                "value": "resident"
            },
            {
                "code": "ushome.dwellings",
                "label": "Dwellings",
                "value": "dweling"
            },
            {
                "code": "payment",
                "label": "Payment",
                "value": "payment"
            },
            {
                "code": "documents",
                "label": "Documents",
                "value": "documents"
            },
            {
                "code": "notes",
                "label": "Notes",
                "value": "note"
            },
            {
                "code": "history",
                "label": "History",
                "value": "history"
            },
            {
                "code": "logs",
                "label": "API Logs",
                "value": "logs"
            }
        ]
    },
    {
        "userType": "client",
        "menu": [
            {
                "code": "summary",
                "label": "Summary",
                "value": "summary"
            },
            {
                "code": "renewal",
                "label": "Renewal",
                "value": "renewal"
            },
            {
                "code": "documents",
                "label": "Documents",
                "value": "documents"
            }
        ]
    }
]
